<template>
  <div id="navMenu">
    <!-- 面包导航 -->
    <el-breadcrumb
      separator="/"
      style="padding-left: 10px; padding-bottom: 10px; font-size: 12px"
    >
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>导航菜单管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 导航菜单列表卡片区 -->
    <el-card class="box-card">
      <el-form :inline="true" ref="form" :model="queryMap" label-width="70px">
        <el-form-item label="菜单名称">
          <el-input
            @keyup.enter.native="searchNavMenu"
            @clear="searchNavMenu"
            clearable
            v-model="queryMap.name"
            placeholder="请输入导航菜单名称查询"
          ></el-input>
        </el-form-item>

        <el-form-item label="导航位置">
          <el-select
            clearable
            @change="searchNavMenu"
            @clear="searchNavMenu"
            v-model="queryMap.position"
            placeholder="请选择导航位置"
          >
            <el-option label="底部导航（TabBar）" value="1"></el-option>
            <el-option label="顶部导航" value="2"></el-option>
            <el-option label="中间悬浮导航" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态">
          <el-select
            clearable
            @change="searchNavMenu"
            @clear="searchNavMenu"
            v-model="queryMap.status"
            placeholder="请选择状态"
          >
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="margin-left: 50px">
          <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
          <el-button type="primary" @click="searchNavMenu" icon="el-icon-search"
            >查询</el-button
          >
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addDialogVisible = true"
            v-hasPermission="'navMenu:add'"
            >添加</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 表格区域 -->
      <el-table
        v-loading="loading"
        :data="navMenuList"
        border
        style="width: 100%"
        height="660"
      >
        <el-table-column label="#" prop="id" width="50"></el-table-column>
        <el-table-column
          prop="name"
          label="菜单名称"
          width="150"
        ></el-table-column>
        <el-table-column label="默认图标" width="120">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.icon"
              :preview-src-list="[scope.row.icon]"
              style="width: 40px; height: 40px; object-fit: cover"
              placeholder="暂无图标"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="选中图标" width="120">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.active_icon || scope.row.icon"
              :preview-src-list="[scope.row.active_icon || scope.row.icon]"
              style="width: 40px; height: 40px; object-fit: cover"
              placeholder="无选中图标"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="position" label="导航位置" width="150">
          <template slot-scope="scope">
            {{ formatPosition(scope.row.position) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          label="排序权重"
          width="100"
        ></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-hasPermission="'navMenu:edit'"
              size="mini"
              type="primary"
              icon="el-icon-edit-outline"
              @click="edit(scope.row.id)"
            ></el-button>
            <el-button
              v-hasPermission="'navMenu:delete'"
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="del(scope.row.id)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 10px"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryMap.pageNum"
        :page-sizes="[6, 10, 20, 30]"
        :page-size="queryMap.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>

      <!-- 添加对话框 -->
      <el-dialog
        title="添加导航菜单"
        @close="closeDialog"
        :visible.sync="addDialogVisible"
        width="60%;"
      >
        <el-form
          :model="addForm"
          :label-position="labelPosition"
          :rules="formRules"
          ref="addFormRef"
          label-width="100px"
        >
          <el-form-item label="菜单名称" prop="name">
            <el-input
              v-model="addForm.name"
              placeholder="请输入导航菜单名称（显示在导航栏的文字）"
            ></el-input>
          </el-form-item>

          <el-form-item label="默认图标" prop="icon">
            <el-upload
              class="upload-demo"
              action="/api/upload"
              :on-success="handleIconUploadSuccess"
              :on-error="handleUploadError"
              :show-file-list="false"
              accept="image/*"
              :headers="{ Authorization: 'Bearer ' + getToken() }"
            >
              <el-button size="small" type="primary">上传默认图标</el-button>
            </el-upload>

            <el-image
              v-if="addForm.icon"
              :src="addForm.icon"
              style="
                width: 60px;
                height: 60px;
                margin-top: 10px;
                object-fit: cover;
              "
            ></el-image>
          </el-form-item>

          <el-form-item label="选中状态图标（可选）">
            <el-upload
              class="upload-demo"
              action="/api/upload"
              :on-success="handleActiveIconUploadSuccess"
              :on-error="handleUploadError"
              :show-file-list="false"
              accept="image/*"
              :headers="{ Authorization: 'Bearer ' + getToken() }"
            >
              <el-button size="small" type="primary">上传选中图标</el-button>
            </el-upload>

            <el-image
              v-if="addForm.active_icon"
              :src="addForm.active_icon"
              style="
                width: 60px;
                height: 60px;
                margin-top: 10px;
                object-fit: cover;
              "
            ></el-image>
            <div style="font-size: 12px; color: #888; margin-top: 5px">
              提示：未上传则使用默认图标
            </div>
          </el-form-item>

          <el-form-item label="导航位置" prop="position">
            <el-select
              v-model="addForm.position"
              placeholder="请选择导航栏位置"
            >
              <el-option label="底部导航（TabBar）" value="1"></el-option>
              <el-option label="顶部导航" value="2"></el-option>
              <el-option label="中间悬浮导航" value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="排序权重" prop="sort">
            <el-input
              v-model.number="addForm.sort"
              placeholder="越小越靠前，默认0"
            ></el-input>
            <div style="font-size: 12px; color: #888; margin-top: 5px">
              提示：数值越小，展示时越靠前
            </div>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-switch
              v-model="addForm.status"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="addNavMenu"
            :loading="btnLoading"
            :disabled="btnDisabled"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <!-- 编辑对话框 -->
      <el-dialog
        title="编辑导航菜单"
        :visible.sync="editDialogVisible"
        width="60%"
        @close="editClose"
      >
        <el-form
          :model="editForm"
          :label-position="labelPosition"
          :rules="formRules"
          ref="editFormRef"
          label-width="100px"
        >
          <el-input type="hidden" v-model="editForm.id"></el-input>

          <el-form-item label="菜单名称" prop="name">
            <el-input
              v-model="editForm.name"
              placeholder="请输入导航菜单名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="当前默认图标">
            <el-image
              :src="editForm.icon"
              style="width: 60px; height: 60px; object-fit: cover"
              placeholder="暂无图标"
            ></el-image>
          </el-form-item>

          <el-form-item label="更换默认图标">
            <el-upload
              class="upload-demo"
              action="/api/upload"
              :on-success="handleEditIconUploadSuccess"
              :on-error="handleUploadError"
              :show-file-list="false"
              accept="image/*"
              :headers="{ Authorization: 'Bearer ' + getToken() }"
            >
              <el-button size="small" type="primary">上传新默认图标</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item label="当前选中图标">
            <el-image
              :src="editForm.active_icon || editForm.icon"
              style="width: 60px; height: 60px; object-fit: cover"
              placeholder="无选中图标"
            ></el-image>
          </el-form-item>

          <el-form-item label="更换选中图标（可选）">
            <el-upload
              class="upload-demo"
              action="/api/upload"
              :on-success="handleEditActiveIconUploadSuccess"
              :on-error="handleUploadError"
              :show-file-list="false"
              accept="image/*"
              :headers="{ Authorization: 'Bearer ' + getToken() }"
            >
              <el-button size="small" type="primary">上传新选中图标</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item label="导航位置" prop="position">
            <el-select
              v-model="editForm.position"
              placeholder="请选择导航栏位置"
            >
              <el-option label="底部导航（TabBar）" value="1"></el-option>
              <el-option label="顶部导航" value="2"></el-option>
              <el-option label="中间悬浮导航" value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="排序权重" prop="sort">
            <el-input
              v-model.number="editForm.sort"
              placeholder="越小越靠前"
            ></el-input>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-switch
              v-model="editForm.status"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="updateNavMenu"
            :loading="btnLoading"
            :disabled="btnDisabled"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 基础状态
      loading: true,
      btnLoading: false,
      btnDisabled: false,
      labelPosition: "right",
      total: 0,

      // 对话框控制
      addDialogVisible: false,
      editDialogVisible: false,

      // 查询参数
      queryMap: {
        pageNum: 1,
        pageSize: 6,
        name: "",
        position: "",
        status: "",
      },

      // 数据列表
      navMenuList: [],

      // 表单数据
      addForm: {
        name: "",
        icon: "",
        active_icon: "",
        position: 1,
        status: 1,
        sort: 0,
      },
      editForm: {},

      // 表单验证规则
      formRules: {
        name: [
          { required: true, message: "请输入菜单名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "名称长度在1-20个字符之间",
            trigger: "blur",
          },
        ],
        icon: [{ required: true, message: "请上传默认图标", trigger: "blur" }],
        position: [
          { required: true, message: "请选择导航位置", trigger: "blur" },
        ],
        sort: [
          { type: "number", message: "排序权重必须为数字", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    // 格式化导航位置显示文本
    formatPosition(position) {
      const posMap = {
        1: "底部导航（TabBar）",
        2: "顶部导航",
        3: "中间悬浮导航",
      };
      return posMap[position] || "未知位置";
    },

    // 加载导航菜单列表
    async getNavMenuList() {
      this.loading = true;
      try {
        const { data: res } = await this.$http.get("navMenu/list", {
          params: this.queryMap,
        });
        if (res.code !== 200)
          return this.$message.error("获取导航菜单列表失败");
        this.navMenuList = res.data.rows;
        this.total = res.data.total;
      } catch (error) {
        this.$message.error("获取数据失败，请重试");
      } finally {
        this.loading = false;
      }
    },

    // 搜索导航菜单
    searchNavMenu() {
      this.queryMap.pageNum = 1;
      this.getNavMenuList();
    },

    // 重置查询条件
    reset() {
      this.queryMap = {
        pageNum: 1,
        pageSize: 6,
        name: "",
        position: "",
        status: "",
      };
      this.getNavMenuList();
    },

    // 分页相关
    handleSizeChange(newSize) {
      this.queryMap.pageSize = newSize;
      this.getNavMenuList();
    },
    handleCurrentChange(current) {
      this.queryMap.pageNum = current;
      this.getNavMenuList();
    },

    // 默认图标上传成功回调
    handleIconUploadSuccess(response) {
      if (response.code === 200) {
        this.addForm.icon = response.data.url;
        this.$message.success("默认图标上传成功");
      } else {
        this.$message.error("默认图标上传失败：" + response.msg);
      }
    },

    // 选中图标上传成功回调
    handleActiveIconUploadSuccess(response) {
      if (response.code === 200) {
        this.addForm.active_icon = response.data.url;
        this.$message.success("选中图标上传成功");
      } else {
        this.$message.error("选中图标上传失败：" + response.msg);
      }
    },

    // 编辑页默认图标上传成功回调
    handleEditIconUploadSuccess(response) {
      if (response.code === 200) {
        this.editForm.icon = response.data.url;
        this.$message.success("默认图标更新成功");
      } else {
        this.$message.error("默认图标更新失败：" + response.msg);
      }
    },

    // 编辑页选中图标上传成功回调
    handleEditActiveIconUploadSuccess(response) {
      if (response.code === 200) {
        this.editForm.active_icon = response.data.url;
        this.$message.success("选中图标更新成功");
      } else {
        this.$message.error("选中图标更新失败：" + response.msg);
      }
    },

    // 上传失败回调
    handleUploadError() {
      this.$message.error("图标上传失败，请检查网络");
    },

    // 添加导航菜单
    async addNavMenu() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;

        this.btnLoading = true;
        this.btnDisabled = true;
        try {
          const { data: res } = await this.$http.post(
            "navMenu/add",
            this.addForm
          );
          if (res.code === 200) {
            this.$notify.success({
              title: "成功",
              message: "导航菜单添加成功",
            });
            this.addDialogVisible = false;
            this.getNavMenuList();
          } else {
            this.$message.error("添加失败：" + res.msg);
          }
        } catch (error) {
          this.$message.error("添加失败，请重试");
        } finally {
          this.btnLoading = false;
          this.btnDisabled = false;
        }
      });
    },

    // 编辑导航菜单
    async edit(id) {
      try {
        const { data: res } = await this.$http.get(`navMenu/${id}`);
        if (res.code !== 200)
          return this.$message.error("获取导航菜单详情失败");
        this.editForm = { ...res.data };
        this.editDialogVisible = true;
      } catch (error) {
        this.$message.error("获取详情失败，请重试");
      }
    },

    // 更新导航菜单
    async updateNavMenu() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;

        this.btnLoading = true;
        this.btnDisabled = true;
        try {
          const { data: res } = await this.$http.put(
            `navMenu/update/${this.editForm.id}`,
            this.editForm
          );
          if (res.code === 200) {
            this.$notify.success({
              title: "成功",
              message: "导航菜单更新成功",
            });
            this.editDialogVisible = false;
            this.getNavMenuList();
          } else {
            this.$message.error("更新失败：" + res.msg);
          }
        } catch (error) {
          this.$message.error("更新失败，请重试");
        } finally {
          this.btnLoading = false;
          this.btnDisabled = false;
        }
      });
    },

    // 删除导航菜单
    async del(id) {
      try {
        const confirm = await this.$confirm(
          "此操作将永久删除该导航菜单，是否继续？",
          "警告",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );

        if (confirm !== "confirm") return;

        const { data: res } = await this.$http.delete(`navMenu/delete/${id}`);
        if (res.code === 200) {
          this.$notify.success({ title: "成功", message: "导航菜单删除成功" });
          this.getNavMenuList();
        } else {
          this.$message.error("删除失败：" + res.msg);
        }
      } catch (error) {
        if (error !== "cancel") {
          this.$message.error("删除失败，请重试");
        }
      }
    },

    // 切换状态
    async changeStatus(row) {
      const originalStatus = row.status;
      try {
        const { data: res } = await this.$http.put(
          `navMenu/updateStatus/${row.id}/${row.status}`
        );
        if (res.code !== 200) {
          row.status = originalStatus; // 回滚状态
          return this.$message.error("状态更新失败：" + res.msg);
        }
        this.$notify.success({
          title: "成功",
          message: `导航菜单已${row.status === 1 ? "启用" : "禁用"}`,
        });
      } catch (error) {
        row.status = originalStatus; // 回滚状态
        this.$message.error("状态更新失败，请重试");
      }
    },

    // 关闭添加对话框
    closeDialog() {
      this.$refs.addFormRef.clearValidate();
      this.addForm = {
        name: "",
        icon: "",
        active_icon: "",
        position: 1,
        status: 1,
        sort: 0,
      };
    },

    // 关闭编辑对话框
    editClose() {
      this.$refs.editFormRef.clearValidate();
      this.editForm = {};
    },

    // 获取Token
    getToken() {
      return localStorage.getItem("token") || "";
    },
  },

  created() {
    this.getNavMenuList();
  },
};
</script>

<style scoped>
.upload-demo {
  margin-bottom: 10px;
}
</style>
